"use client";
import { getRadius, getShadow } from "../../core/utils/get-size/get-size.mjs";
import { createVarsResolver } from "../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { polymorphicFactory } from "../../core/factory/polymorphic-factory.mjs";
import { Box } from "../../core/Box/Box.mjs";
import Paper_module_default from "./Paper.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Paper/Paper.tsx
const varsResolver = createVarsResolver((_, { radius, shadow }) => ({ root: {
	"--paper-radius": radius === void 0 ? void 0 : getRadius(radius),
	"--paper-shadow": getShadow(shadow)
} }));
const Paper = polymorphicFactory((_props) => {
	const props = useProps("Paper", null, _props);
	const { classNames, className, style, styles, unstyled, withBorder, vars, radius, shadow, variant, mod, attributes, ...others } = props;
	const getStyles = useStyles({
		name: "Paper",
		props,
		classes: Paper_module_default,
		className,
		style,
		classNames,
		styles,
		unstyled,
		attributes,
		vars,
		varsResolver
	});
	return /* @__PURE__ */ jsx(Box, {
		mod: [{ "data-with-border": withBorder }, mod],
		...getStyles("root"),
		variant,
		...others
	});
});
Paper.classes = Paper_module_default;
Paper.varsResolver = varsResolver;
Paper.displayName = "@mantine/core/Paper";
//#endregion
export { Paper };

//# sourceMappingURL=Paper.mjs.map